/** Approved suppliers for contract dropdowns (KCG shared doc 7/06 — Juan). */
export const APPROVED_SUPPLIER_NAMES = [
  'Criadero del Carmen',
  'GBC Portugal',
] as const

function normalizeSupplierName(name: string): string {
  return name.trim().toLowerCase().replace(/,?\s*lda\.?$/i, '').trim()
}

export function isApprovedSupplierName(name: string): boolean {
  const n = normalizeSupplierName(name)
  return APPROVED_SUPPLIER_NAMES.some((s) => normalizeSupplierName(s) === n)
}

export function filterApprovedVendors<T extends { name: string }>(vendors: T[]): T[] {
  return vendors.filter((v) => isApprovedSupplierName(v.name))
}
